import React from "react";
import { Box, Paper, Stack, Tabs, TextField, Typography, Tab, withStyles } from "@mui/material";
import { ColorUtils } from "../utils/ColorUtils";

interface Props {
  elevation?: number;
  rightContent?: JSX.Element;
  children?: React.ReactNode;
  selectedTab: number;
  handleTabChange: (event: React.SyntheticEvent, tab: number) => void;
  tabs: string[];
}

export default function GenericTabComponent({ elevation = 0, rightContent, children, selectedTab, handleTabChange, tabs }: Props) {
  return (
    <>
      <Paper elevation={elevation} style={{ padding: "10px", border: `1px solid ${ColorUtils.LIGHTER_GRAY}`, backgroundColor: "#FAFBFC" }}>
        <Tabs value={selectedTab} onChange={handleTabChange} style={{ paddingBottom: "0.5em" }}>
          {tabs.map((t: string) => {
            return <Tab label={t} />;
          })}
        </Tabs>
      </Paper>
    </>
  );
}
